import React from 'react';
import PropTypes from 'prop-types';
import Message, {getMessage} from '../common/Message';
import Select from 'epic-diesel-form/src/components/form/Select';
import getInfluencersFlowSchema from '../../data/InfluencersFlowSchema';
import styles from './Payout.pcss';

const payoutInfoConstants = {
    GATEWAY_TYPE: {
        PAYPAL: 'paypal',
        BANK: 'bank'
    }
};

export default class Payout extends React.Component {
    static propTypes = {
        messages: PropTypes.object.isRequired,
        form: PropTypes.object,
        trigger: PropTypes.func,
        disabled: PropTypes.bool
    };

    render() {
        const {messages, form, trigger, disabled} = this.props;
        const payoutInfoSchema = getInfluencersFlowSchema(getMessage, messages).payoutInfo;
        const methods = [
            {
                value: payoutInfoConstants.GATEWAY_TYPE.PAYPAL,
                label: payoutInfoSchema.gatewayType.optionLabel.payPal
            },
            {
                value: payoutInfoConstants.GATEWAY_TYPE.BANK,
                label: payoutInfoSchema.gatewayType.optionLabel.bank
            }
        ];

        return (
            <div className={styles.section}>
                <div className={styles.title}>
                    <Message code="epic.affiliate.settings.payout_title" />
                </div>
                <div className={styles.desc}>
                    <Message code="epic.affiliate.settings.payout_description" />
                </div>
                <div className={styles.row}>
                    <Select
                        name="payoutMethod"
                        value={form.payoutMethod}
                        options={methods}
                        onChange={trigger}
                        disabled={disabled}
                    />
                </div>
            </div>
        );
    }
}
